// React import removed
import { Link, useLocation } from 'react-router-dom'
import {
  HomeIcon,
  BuildingOfficeIcon,
  UsersIcon,
  TrophyIcon,
  ChartBarIcon,
} from '@heroicons/react/24/outline'

interface AdminLayoutProps {
  children: React.ReactNode
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const location = useLocation()

  const navigation = [
    { name: 'Overview', href: '/admin', icon: HomeIcon },
    { name: 'Churches', href: '/admin/churches', icon: BuildingOfficeIcon },
    { name: 'Users', href: '/admin/users', icon: UsersIcon },
    { name: 'Competitions', href: '/admin/competitions', icon: TrophyIcon },
    { name: 'Tournaments', href: '/admin/tournaments', icon: ChartBarIcon },
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="flex">
        {/* Sidebar */}
        <div className="w-64 bg-white shadow-sm">
          <div className="flex flex-col h-screen">
            <div className="flex items-center justify-center h-16 px-4 bg-primary-600">
              <h1 className="text-xl font-bold text-white">Admin Portal</h1>
            </div>
            
            <nav className="flex-1 px-4 py-6 space-y-2">
              {navigation.map((item) => {
                const isActive = location.pathname === item.href ||
                  (item.href !== '/admin' && location.pathname.startsWith(item.href))
                
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                      isActive
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    <item.icon className="mr-3 h-5 w-5" />
                    {item.name}
                  </Link>
                )
              })}
            </nav>
          </div>
        </div>

        {/* Main content */}
        <div className="flex-1">
          <main className="p-8">
            {children}
          </main>
        </div>
      </div>
    </div>
  )
}

export default AdminLayout